import React from 'react';
import PropTypes from 'prop-types';
import IMAGES from 'modules/assets/web';
import Toast from 'modules/toast';
import { Link } from 'react-router-dom';

const CompleteWaiver = props => {
  const { waiverCheck } = props;
  if (props.myWaiver.data.length <= 0) {
    Toast.error(
      'Error loading waiver. Please refresh the page or contact customer support',
    );
    return null;
  }
  return (
    <div className="page onboarding flex-1 col-md-9 ml-auto p-0">
      <div className="page--content">
        <img
          alt="page-background"
          className="page-background-image"
          src={IMAGES.DOTTED_BACKGROUND}
        />
        <div className="container page__complete-waiver">
          <div className="row">
            <div className="col">
              <h1>Waiver Time!</h1>
              <p>
                Click the button below to sign your NF Coaching waiver. It will
                open up in a new tab; once your waiver is complete, return here
                to answer a questionnaire about your current lifestyle, habits,
                and goals!
              </p>

              <a target="_blank" href={props.myWaiver.data[0].signUrl}>
                <button className="btn btn-primary btn-large px-3  mb-2">
                  <h5 className=" my-2 extra-letter-spacing">Go Sign Waiver</h5>
                </button>
              </a>
              <p>
                {`Once you've completed and signed the waiver, return here. You will automatically continue on once it finds your signed waiver, or you can press the button below to manually check.`}
              </p>
              <button
                className="btn btn-large btn-nf-secondary px-3 "
                onClick={waiverCheck}
              >
                <h5 className=" my-2 extra-letter-spacing">
                  Check Waiver Completion
                </h5>
              </button>
              {props.checkingWaiver && (
                <div className="d-flex flex-column justify-content-center align-items-start mt-2">
                  <span>Checking Waiver Status...</span>

                  <Link to="/onboarding/?bypassWaiver=true" className="mr-1">
                    Due to an error in the signing service, if you have already
                    completed the waiver please use this link to continue.
                  </Link>
                  <img
                    alt="Loading..."
                    className=""
                    src={IMAGES.NF_LOADING_GRADIENT}
                  />
                </div>
              )}
            </div>
            <div className="col mobile-mt-2 text-center">
              <img
                alt="Loading..."
                className=""
                src={IMAGES.ONBOARDING_WAIVER_CLIPBOARD}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CompleteWaiver.propTypes = {
  myWaiver: PropTypes.object.isRequired,
  waiverCheck: PropTypes.func.isRequired,
  isHiddenSidebar: PropTypes.bool.isRequired,
  checkingWaiver: PropTypes.bool.isRequired,
};

export default CompleteWaiver;
